import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import AddCategory from "./AddFoods.jsx";
import Out from "./Out.jsx";
import "./App.css";
import ItemsDashboard from "./ItemsDashboard.jsx";
import LoginPage from "./LogIn.jsx";
import Main from "./Main.jsx";

function App() {
  return <Main />;
  // return <AddCategory/>
  // return <Out />;
  // return <ItemsDashboard/>
  // return <LoginPage/>
  // return(
  // <Router>
  //   <Routes>
  //   <Route path="/" element={<LoginPage/>} />
  //   <Route path="/adminPanel" element={<ItemsDashboard/>} />
  //   <Route path="/menu" element={<Main/>} />
  //   </Routes>
  // </Router>
  // );
}

export default App;
